export default {
  name: "CertificatesAndReports",

  data() {
    return ({
      /* ===============================
         UI STATE
         =============================== */
      active_tab: "bee_certificates",
      is_loading: false,
      error_message: null,

      /* ===============================
         TABS CONFIG
         =============================== */
      tabs: [
        { key: "bee_certificates", label: "BEE Certificates", icon: "bi-award" },
        { key: "internal_assessments", label: "Internal Assessments", icon: "bi-clipboard-check" },
        { key: "advisory_opinions", label: "Advisory Opinions", icon: "bi-chat-left-text" },
        { key: "csd_documents", label: "CSD Documents", icon: "bi-file-earmark-text" },
      ],

      /* ===============================
         SUMMARY
         =============================== */
      summary: {
        total_documents: 0,
      },

      /* ===============================
         CERTIFICATES & REPORTS DATA
         =============================== */
      certificates_reports: {
        bee_certificates: {
          count: 0,
          label: "BEE Certificates",
          description: "Official B-BBEE verification certificates and reports",
          icon: "bi-award-fill",
        },

        internal_assessments: {
          count: 0,
          label: "Internal Assessments",
          description: "Quarterly and annual internal BEE score calculations",
          icon: "bi-clipboard-check-fill",
        },

        advisory_opinions: {
          count: 0,
          label: "Advisory Opinions",
          description: "Formal advisory and opinion letters",
          icon: "bi-chat-left-text-fill",
        },

        csd_documents: {
          count: 0,
          label: "CSD Documents",
          description: "Central Supplier Database documents",
          icon: "bi-file-earmark-text-fill",
        },
      },
    });
  },

  /* ===============================
     COMPUTED
     =============================== */
  computed: ({
    /**
     * Total documents badge
     */
    total_documents() {
      return this.summary.total_documents;
    },


    current_tab() {
      return this.certificates_reports[this.active_tab] || {};
    },
  }),

  mounted() {
    this.summary.total_documents = 12;
    this.certificates_reports.bee_certificates.count = 3;
    this.certificates_reports.internal_assessments.count = 4;
    this.certificates_reports.advisory_opinions.count = 2;
    this.certificates_reports.csd_documents.count = 3;
  },
  methods: {
    set_active_tab(tab_key) {
      this.active_tab = tab_key;
    },
  },
};
